module.controller('signupSigninCtrl', [
  'brandService', 'cardOrderService', 'localStorageService', '$state', '$http','baseURI', 'Transform', 'authService', '$timeout', 'referrerService',
  function(brandService, cardOrderService, localStorageService, $state, $http, baseURI, Transform, authService, $timeout, referrerService) {

  var vm = this;
  var cards = cardOrderService.getCards();
  var brand = brandService.getBrand();

  vm.currentCard = cardOrderService.getCurrentCard();
  vm.submitted = false;
  vm.checkEmail = checkEmail;
  vm.checkPressedKey = checkPressedKey;

  init();

  ///////////////////////////////

  function init() {

    if (cards && cards[0] === undefined) {
      cards = localStorageService.get('cardOrder');
      if (!cards) {
        $state.go('signup.create');
      }
    }
    if (cards && cards[0] !== null && cards[0].CardPurpose == 'personal') {
      defineLoginData();
    }
  }

  function defineLoginData() {
    if (cards[0]) {

      vm.loginData = {
        'FirstName': cards[0].FirstName,
        'LastName': cards[0].LastName,
        'Email':  cards[0].Email ? cards[0].Email : '',
        'Phone': cards[0].Phone ? cards[0].Phone : ''
      };
    }
  }

  function checkPressedKey(event){
    if (event.keyCode === 13) {
      vm.submitCode();
    }
  }

  function checkEmail(isValid) {
    vm.submitted = true;

    if(isValid){
      var email = vm.loginData.Email;
      vm.submitted = false;
      vm.loading = true;

      $http({
        method: 'POST',
        url: baseURI + 'cardholder/checkemail',
        headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
        data: 'Email=' + encodeURIComponent(email)
      }).then(function (resp){
        var data = resp.data;

        if (!data.Success) {
          vm.loading = false;
          vm.showError = true;
          vm.errorMessage = data.ErrorMessage;
        } else {
          vm.showError = false;
          createVerificationCode();
        }
      }).catch(function (error){
        vm.loading = false;
        vm.showError = true;
        vm.errorMessage = 'Sorry, we were unable to process your info at this time. Please try again later.';
      }).then(function() {
      });
    }
  }

  function login() {
    vm.loginData._key = brand.api_key;
    vm.loginData.SourceChannel = referrerService.getSourceChannel();
    vm.loginData.SourceCampaign = referrerService.getSourceCampaign();
    vm.loginData.SourceTags = referrerService.getSourceTags();
    vm.loading = true;

    $http({
      url: baseURI + 'member/create',
      method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      data: Transform.encode(vm.loginData)
    }).then(function (resp){
      var data = resp.data;

      if(data.Success){
        // auto authenticate user
        authService.handleAutoAuthSignup(data, cardOrderService.addCard, vm.currentCard, true);
      }
    }).catch(function (error){
      vm.loading = false;
      vm.showError = true;
      vm.errorMessage = 'Sorry, we were unable to process your info at this time. Please try again later.';
    });
  }

  // Make request for validation Code
  // This function is copied from step-1-joinCtrl.js. Adding it here because
  // in a rush - we should extract it as a service and avoid duplication
  function createVerificationCode() {
    var reqData = {
      Email: vm.loginData.Email,
      _key: brand.api_key
    };

    $http({
      url: baseURI + 'email/verification',
      method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      data: Transform.encode(reqData)
    }).then(function (resp){
      var data = resp.data;

      vm.loading = false;
      if(data.Success){
        // Open the modal
        vm.showValidateEmail = true;
        startCountDown();
      } else {
        vm.showError = true;
        vm.errorMessage = 'Sorry, we were unable to verify your email address at this time. Please try again later.';
      }
    }).catch(function(error){
      vm.loading = false;
      vm.showError = true;
      vm.errorMessage = 'Sorry, we were unable to verify your email address at this time. Please try again later.';
    });
  }

  // This function is copied from step-1-joinCtrl.js. Adding it here because
  // in a rush - we should extract it as a service and avoid duplication
  function startCountDown() {
    vm.counter = 1200;

    vm.onTimeout = function(){
      vm.counter--;
      if(vm.counter > 1){
        myTimeout = $timeout(vm.onTimeout, 1000);
      } else {
        vm.stopTimeout();
        vm.showValidateEmail = false;
      }
    };

    // Create the promise
    var myTimeout = $timeout(vm.onTimeout, 1000);

    // Cancel the promise
    vm.stopTimeout = function() {
      $timeout.cancel(myTimeout);
    };

  }

  // User has successfully completed email verification
  // This function is copied from step-1-joinCtrl.js. Adding it here because
  // in a rush - we should extract it as a service and avoid duplication
  function successVerfication() {
    login();
  }

  // User clicks on resend email link
  // This function is copied from step-1-joinCtrl.js. Adding it here because
  // in a rush - we should extract it as a service and avoid duplication
  vm.reSend = function(){
    vm.stopTimeout();
    vm.loadingEmailVerification = true;
    createVerificationCode();
  };

  // This function is copied from step-1-joinCtrl.js. Adding it here because
  // in a rush - we should extract it as a service and avoid duplication
  vm.close = function(){
    // Close the modal
    vm.stopTimeout();
    vm.showValidateEmail = false;
  };

  // User is manually submitting code
  // This function is copied from step-1-joinCtrl.js. Adding it here because
  // in a rush - we should extract it as a service and avoid duplication
  vm.submitCode = function(){
    //store the email and phone for when the user returns to the page
    if(cards[0]){
      cards[0].Email = vm.loginData.Email;
      cards[0].Phone = vm.loginData.Phone;
    }

    if(!vm.loginData.VerificationCode){
      vm.attemptedVerify = true;
      vm.invalidVerify = false;
    } else {
      vm.loading = true;
      vm.attemptedVerify = false;
      var verifiedReq = {
        Email: vm.loginData.Email,
        VerificationCode: vm.loginData.VerificationCode
      };

      $http({
        url: baseURI + 'email/verification',
        method: 'PUT',
        headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
        data: Transform.encode(verifiedReq)
      }).then(function(resp){
        var data = resp.data;

        vm.loading = false;
        vm.invalidVerify = !data.Success;
        if(data.Success){
          vm.stopTimeout();
          successVerfication();
        }
      }).catch(function(error){
        vm.invalidVerify = true;
        vm.loading = false;
      });
    }
  };

}]);
